import { render, staticRenderFns } from "./IndividualsPreviewList.vue?vue&type=template&id=4fa083be"
import script from "./IndividualsPreviewList.vue?vue&type=script&lang=ts"
export * from "./IndividualsPreviewList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports